module.exports = __webpack_public_path__ + "images/5883cc9bf5dd978294eddb68656da7b0.jpg";